import { useMemo } from 'react';

import { RBParsedRail } from 'store/railsBuilder/reducer.types';

import { ContentType } from 'services/data-manager/types';

import {
    metadataTypeToRibbonType,
    stripeDimensions,
    stripeMargins,
} from 'components/CustomButtons/RibbonTouchable/styles';

function useSnapOffset(
    ribbonItems: RBParsedRail['sections'],
    metadataType: ContentType,
) {
    return useMemo(() => {
        let currentOffset = 0;
        const snapOffsets: number[] = [];
        const ribbonType = metadataTypeToRibbonType[metadataType];

        if (
            ribbonType &&
            stripeDimensions[ribbonType] &&
            stripeMargins[metadataType]
        ) {
            ribbonItems.forEach(() => {
                currentOffset +=
                    stripeDimensions[ribbonType].width +
                    stripeMargins[metadataType]!.marginRight;
                snapOffsets.push(currentOffset);
            });
        }

        return snapOffsets;
    }, [ribbonItems, metadataType]);
}

export default useSnapOffset;
